/*
  This is the notification panel
 */

import React from 'react'
import { connect } from "react-redux";
import store from "../store/store";

class Notice extends React.Component {
    noticeMessages(noticeType){
        if(this.props.notices == null){
            return
        }
        const style = this.props.addPadding ? {padding: '0 10px'} : null
        return this.props.notices.map((notice) =>

            <div className={"alert-box " +  noticeType} data-alert="">
                <div className="row">
                    <div className="small-12 columns">
                        <span>
                            <div className={"notice " + noticeType} style={style} key={notice.notice_type}>{notice.message}</div>
                        </span>
                    </div>
                </div>
            </div>
            )
    }

    isSuccessNotice(){
        // success notice occurrs when successfully saved, therefore it should only have length of 1
        if( this.props.notices.length != 1){
            return false;
        } else if(this.props.notices[0].notice_type == 'success'){
            return true;
        }

        return false;
    }

    handleClose(e){
        e.preventDefault();
        // we can close the notice by removing everything from the store
        store.dispatch({type: 'CLEAR_NOTICES'})
    }

    render() {
        if(this.props.notices.length == 0){
            //we dont want anything to render
            return ""
        }
        const noticeType = this.isSuccessNotice() ? "success" : "error"
        return (
            <div className="notice-wrapper">
                    { this.noticeMessages(noticeType) }
            </div>
        )
    }
}
const mapStateToProps = state =>{
    return {
        notices: state.notices
    }
};
export default connect(mapStateToProps)(Notice);
